if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
  var boostPFSFilterConfig = {
    general: {
      limit: boostPFSConfig.custom.products_per_page,
      loadProductFirst: true,
      styleScrollToTop: 'style2',
      numberFilterTree: 2,
      defaultDisplay: boostPFSThemeConfig.custom.layout,
      selectOptionContainer: '.grid__item .card-wrapper',
      stickyFixTopPos: true,
      showPlaceholderProductList: true,
      filterTreeMobileStyle: 'style1'
    },
    selector: {
      otpTopCartCount: '.cart-count-bubble'
    }
  };
}

(function () {
  var onSale = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    boostPFSRangeWidths = [165, 350, 533, 720, 940, 1066];


  BoostPFS.inject(this);
  /* For Filter Setting Layout */
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {
    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';
    var ratioImage = getRatioImage(data);
    var imageAspectRatio = ratioImage / getAspectRatio(data.images_info[0]) * 100;

    itemHtml = itemHtml.replace(/{{imageAspectRatio}}/g, imageAspectRatio);
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);


    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add Card product class
    itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass(data));
    // Add Card inner product class
    itemHtml = itemHtml.replace(/{{cardInnerProductClass}}/g, buildCardInnerProductClass(data));
    // Add Card badge position
    itemHtml = itemHtml.replace(/{{cardBadgePosition}}/g, boostPFSThemeConfig.custom.badge_position);
    // Add check card heading five
    itemHtml = itemHtml.replace(/{{cardIsHeadingFive}}/g, buildCardIsHeadingFive(data));
    // Add sold out Label
    itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
    // Add sale Label
    itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
    // Add Images
    var imgId = 'ProductCardImage-'+ data.id;
    var wrapperId = 'ProductCardImageWrapper-'+ data.id;
    var aspect_ratio = '';
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
        itemImagesHtml += '<div class="product-thumbnail lazyload" style="background-image: url(' + Utils.getFeaturedImage(images, '350x350') + '); " >';
        itemImagesHtml += '<div class="product-overlay"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" fill="none" xmlns:v="https://vecta.io/nano"><g clip-path="url(#A)"><path d="M26.813 16.844v2.062c0 .567-.464 1.03-1.03 1.03h-5.844v5.844c0 .567-.464 1.03-1.03 1.03h-2.062c-.567 0-1.03-.464-1.03-1.03v-5.844H9.97c-.567 0-1.03-.464-1.03-1.03v-2.062c0-.567.464-1.03 1.03-1.03h5.844V9.97c0-.567.464-1.03 1.03-1.03h2.062c.567 0 1.03.464 1.03 1.03v5.844h5.844c.567 0 1.03.464 1.03 1.03zM43.7 41.757L41.757 43.7a1.03 1.03 0 0 1-1.461 0L29.863 33.266a1.02 1.02 0 0 1-.301-.73v-1.134c-3.137 2.707-7.22 4.348-11.687 4.348C8 35.75 0 27.75 0 17.875S8 0 17.875 0 35.75 8 35.75 17.875c0 4.47-1.64 8.55-4.348 11.688h1.134c.275 0 .533.112.73.3L43.7 40.296a1.03 1.03 0 0 1 0 1.461zM31.625 17.875a13.75 13.75 0 1 0-27.5 0 13.75 13.75 0 1 0 27.5 0z" fill="#fff"/></g><defs><clipPath id="A"><path fill="#fff" d="M0 0h44v44H0z"/></clipPath></defs></svg></div>';

        

        var shippingLabels = false;
        for (var i = 0; i < data.tags.length; i++) {
          var tag = data.tags[i];
          if ( tag.includes('shipping')){
            shippingLabels = true;
          }
        }
        if( shippingLabels ){
          itemImagesHtml += '<div class="shipping-label" data-shipping-wrapper>';
          for (var i = 0; i < data.tags.length; i++) {
            var tag = data.tags[i];

            if ( tag.includes('shipping fs')){
              var location = tag.split(': ')[1].split('_')[0];
              itemImagesHtml += '<span class="fastship" data-location-fs="' + location + '">';
              itemImagesHtml += '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="#0B4470"/><path d="M14.5902 8.44709H10.0562L12.3168 2.29504L5.40991 11.7168H9.94398L7.68334 17.8688L14.5902 8.44709Z" fill="white"/></svg>';
              itemImagesHtml += 'FastShip</span>';
            }

            if ( tag.includes('shipping fc')){
              var location = tag.split(': ')[1].split('_')[0];
              itemImagesHtml += '<span class="fastcollect" data-location-fc="' + location + '">';
              itemImagesHtml += '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9.71429" fill="#F6F8FB" stroke="#009CDE" stroke-width="0.571429"/><path d="M14.5902 8.44709H10.0562L12.3168 2.29504L5.40991 11.7168H9.94398L7.68334 17.8688L14.5902 8.44709Z" fill="#0C80BA"/></svg>';
              itemImagesHtml += 'FastCollect</span>';
            }

          }
          itemImagesHtml += '</div>';
        }
      
		itemImagesHtml += '<img id="' + imgId + '" ' +
                          'class="hide grid-view-item__image lazyload" ' +
                          'src="' + Utils.getFeaturedImage(images, '350x350') + '" ' +
                          'data-src="' + Utils.getFeaturedImage(images, '350x350') + '" ' +
                          'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
                          'data-aspectratio="' + aspect_ratio + '" ' +
                          'data-sizes="auto" ' +
                          'alt="{{itemTitle}}">';
        itemImagesHtml += '</div>';
        itemImagesHtml += '</div>';
	
		var image_size = boostPFSThemeConfig.custom.max_height + 'x' + boostPFSThemeConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSThemeConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		
    // Comfort Level
    itemHtml = itemHtml.replace(/{{comfortLevel}}/g, buildIComfortLevel(data));

    // 
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
    

    // Add Review
    if (typeof Integration === 'undefined' ||
      (typeof Integration != 'undefined' &&
        typeof Integration.hascompileTemplate == 'function' &&
        !Integration.hascompileTemplate('reviews'))) {
      itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
    }

    // Add Description
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, boostPFSThemeConfig.custom.description || '');

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

    // Build NZ MADE TEXT
    var itemNZmadeTag = buildNzTextTag(data);
    itemHtml = itemHtml.replace(/{{nz-made-beds}}/g, itemNZmadeTag);
  
    // Build SIZE INFO
    var itemCategory = buildCategoryInfo(data);
    itemHtml = itemHtml.replace(/{{bedCategory}}/g, itemCategory);
  
    // Build Kulkote Tag
    var itemKulkote = buildKTag(data);
    itemHtml = itemHtml.replace(/{{tag-kulkote}}/g, itemKulkote);

  
  
    // Build DiscountTag style
    var itemDiscountTag = buildDiscountTag(data);
    itemHtml = itemHtml.replace(/{{discount-tag}}/g, itemDiscountTag);
  
    // Build NewTag style
    var itemNewTag = buildNewTag(data);
    itemHtml = itemHtml.replace(/{{new-tag}}/g, itemNewTag);
  
    // Build SIZE INFO
    var itemSizeInfo = buildSizeInfo(data);
    itemHtml = itemHtml.replace(/{{size-info}}/g, itemSizeInfo);
    
    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };

  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/

  function buildIComfortLevel(data){
    let node = ``
    for (var j = 0; j < data.tags.length; j++) {
      if ( data.tags[j].indexOf("n-comfort") !== -1){
        if ( data.tags[j] == 'n-comfort 1' ){
          node += '<span class="comfort-count">1</span><span class="comfort-label">Firm</span>';
        } else if ( data.tags[j] == 'n-comfort 2' ) {
          node += '<span class="comfort-count">2</span><span class="comfort-label">Firm</span>';
        } else if ( data.tags[j] == 'n-comfort 3' ) {
          node += '<span class="comfort-count">3</span><span class="comfort-label">Firm</span>';
        } else if ( data.tags[j] == 'n-comfort 4' ) {
          node += '<span class="comfort-count">4</span><span class="comfort-label">Med</span>';
        } else if ( data.tags[j] == 'n-comfort 5' ) {
          node += '<span class="comfort-count">5</span><span class="comfort-label">Med</span>';
        } else if ( data.tags[j] == 'n-comfort 6' ) {
          node += '<span class="comfort-count">6</span><span class="comfort-label">Med</span>';
        } else if ( data.tags[j] == 'n-comfort 7' ) {
          node += '<span class="comfort-count">7</span><span class="comfort-label">Med</span>';
        } else if ( data.tags[j] == 'n-comfort 8' ) {
          node += '<span class="comfort-count">8</span><span class="comfort-label">Plush</span>';
        } else if ( data.tags[j] == 'n-comfort 9' ) {
          node += '<span class="comfort-count">9</span><span class="comfort-label">Plush</span>';
        } else if ( data.tags[j] == 'n-comfort 10' ) {
          node += '<span class="comfort-count">10</span><span class="comfort-label">Plush</span>';
        } 
      }
    }
    // console.log('hey,', node);
    return node;
  }
  function buildNzTextTag(data) {
    var nzMadeText = '<div class="nz-made-beds">Quality Guaranteed</div>';
    for (var j = 0; j < data.tags.length; j++){
      if ( data.tags[j].includes("productheadline:") ){
        var thePhraseParts = data.tags[j].split(':');
        var thePhrase = thePhraseParts[1];
        nzMadeText = '<div class="nz-made-beds">'+thePhrase+'</div>';
      }
    }
    return nzMadeText;
  }

  function buildCategoryInfo(data) {
    var type = data.product_type.replace(/type /g, ""),
        BedsCategoryInfo = '';

    if ( type == 'bed' ){
      type = 'Bed Ensemble';
    }
    if ( type == 'mattress' ){
      type = 'Mattress Only';
    }

    BedsCategoryInfo = '<div class="bed-category">' + type + '</div>';
    return BedsCategoryInfo;

  }
  function buildKTag(data) {
    var kTag = '';
    for (var j = 0; j < data.tags.length; j++){
      if (data.tags[j] == 'badge kulkote'){
        kTag += '<div class="kulkote">';
        kTag += '<div class="icon-kulkote">';
        kTag += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="130" height="35" viewBox="0 0 130 35">';
        kTag += '<image x="7" y="5" width="116" height="25" xlink:href="data:img/png;base64,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"/>';
        kTag += '</svg>';
        kTag += '</div>';
        kTag += '</div>';
        break;
      }

      if (data.tags[j] == 'badge optitemp'){
        kTag += '<div class="optitemp category-optitemp">';
        kTag += '<div class="icon-optitemp">';
        kTag += '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="130" height="35" viewBox="0 0 130 35">';
        kTag += '<img src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/Badge_Optitemp_RHS.png?v=1664232521" alt="badge icon">';
        kTag += '</svg>';
        kTag += '</div>';
        kTag += '</div>';
        break;
      }
    }


    return kTag;
  }

  function buildDiscountTag(data) {
    let saleCallOut = false;
    let onePriceCallOut = false;
    let asopDiscount = false;
    let epicDeal = false;
    let zeroDiscount100 = false;
    let zeroDiscount200 = false;
    let everyDayLowPrice = false;
    let saleBadgeNoPercentage = false;
    for (var j = 0; j < data.tags.length; j++){
      if(data.tags[j] == 'SaleCallout') {
        saleCallOut = true;
      }
      if(data.tags[j] === 'range swisstek') {
        onePriceCallOut = true;
      }
      if(data.tags[j]=== 'ASOP' ){
        asopDiscount = false;
      }
      if(data.tags[j] === 'ZEROSAVE100'){
        zeroDiscount100 = true;
      }
      if(data.tags[j] === 'ZEROSAVE200'){
        zeroDiscount200 = true;
      }
      if(data.tags[j] === 'badge eddp'){
        everyDayLowPrice = true;
      }
      if(data.tags[j] === 'badge sale'){
        saleBadgeNoPercentage = true;
      }
      if(data.tags[j] === 'badge epicdeal'){
        saleBadgeNoPercentage = true;
        epicDeal = true;
      }
    }
    var newDiscount = '',
        onSale = data.compare_at_price_min > data.price_min,
        discountPrice = ( data.compare_at_price_min - data.price_min ) / data.compare_at_price_min;

        // console.log('##### boost-pfs-filter', asopDiscount, onSale, saleCallOut, zeroDiscount100, zeroDiscount200)
    if(onSale){
      var DiscountRoundOff = Math.floor(((Math.round((discountPrice * 100 )) / 100) / 5) * 100) * 5;
      if(saleBadgeNoPercentage){
        if(epicDeal) {
          newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0769/2127/4658/files/BRU_Web_Badge_Epic_Deals_V2-200x192.webp?v=1707885297" alt="badge icon" width="72" height="66">';
        } else {
          newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_Sale_V2.svg?v=1715219957">';
        }
      }
      else if(saleCallOut === true ) {
        newDiscount += '<img class="discount-percentage-tag discount-salecallout newdiscount bcsf" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Discount_Callout_Sale-svg.svg?v=1675199605">';
      } else if(asopDiscount){
        newDiscount += '<img class="discount-percentage-tag discount-salecallout asop" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/badge_ASOP-Aug22.svg?v=1659438265">';
      } 
        else {
        if(zeroDiscount100 == false && zeroDiscount200 == false && asopDiscount == false && everyDayLowPrice == false && saleBadgeNoPercentage == false && epicDeal == false){
          if(DiscountRoundOff == 10){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_10.svg?v=1700702858">';
          }else if(DiscountRoundOff == 15){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_15.svg?v=1701730922">';
          }else if(DiscountRoundOff == 20){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_20.svg?v=1700702858">';
          }else if(DiscountRoundOff == 25){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_25.svg?v=1701730923">';
          }else if(DiscountRoundOff == 30){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0769/2127/4658/files/BRU_Web_Badge_30_-200x192.webp?v=1706554164">';
          }else if(DiscountRoundOff == 35){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_35.svg?v=1701730923">';
          }else if(DiscountRoundOff == 40){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_40.svg?v=1700702858">';
          }else if(DiscountRoundOff == 45){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_45.svg?v=1701730923">';
          }else if(DiscountRoundOff == 50){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_50.svg?v=1700702858">';
          }else if(DiscountRoundOff == 55){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_55.svg?v=1701730923">';
          }else if(DiscountRoundOff == 60){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_60.svg?v=1700702858">';
          }else if(DiscountRoundOff == 65){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_65.svg?v=1701730923">';
          } else if(DiscountRoundOff == 70){
            newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_70.svg?v=1700702858">';
          }
        } else {
          if(zeroDiscount100 == true && zeroDiscount200 == false && asopDiscount == false){
            newDiscount += '<img class="discount-percentage-tag tag-zero boost-100 image-has-padding" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/t/227/assets/BRU_Zero_100_Nov21.svg?v=1648244975159873040">';
          } else if(zeroDiscount100 == false && zeroDiscount200 == true){
            newDiscount += '<img class="discount-percentage-tag tag-zero boost-200 image-has-padding" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/t/227/assets/BRU_Zero_200_Nov21.svg?v=3260399604313625750">';
          }
        }
      }


      //newDiscount += '<div class="discount-percentage-tag"><span class="discount">';
      //newDiscount += Math.floor(((Math.round((discountPrice * 100 )) / 100) / 5) * 100) * 5;
      //newDiscount += '</span><span class="percent">%<span class="off">off</span></span></div>';
      // }
    }else if(asopDiscount){
      newDiscount += '<img class="discount-percentage-tag discount-salecallout asop" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/badge_ASOP-Aug22.svg?v=1659438265">';
    }

    else if(everyDayLowPrice) {
      newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0194/5016/7395/files/BRU_Web_Badge_EDLP_V2.svg?v=1701730923" alt="badge icon" width="72" height="66">';
    }

    else if(epicDeal) {
      newDiscount += '<img class="discount-percentage-tag" src="https://cdn.shopify.com/s/files/1/0769/2127/4658/files/BRU_Web_Badge_Epic_Deals_V2-200x192.webp?v=1707885297" alt="badge icon" width="72" height="66">';
    }


    return newDiscount;
  }

  function buildNewTag(data) {
    var newTag = '';
    for (var j = 0; j < data.tags.length; j++){
      if (data.tags[j].indexOf('badge ') !== -1){
        newTag += '<div class="badges">';
        break;
      }
    }

    for (var j = 0; j < data.tags.length; j++){

      if ( data.tags[j] == 'badge clearance' ){
        newTag += '<div class="clearance-tag badge-tag">';
        newTag += ' <span>Clearance</span>';
        newTag += '</div>';
      } else if ( data.tags[j] == 'badge best seller' ){
        newTag += '<div class="best-seller-tag badge-tag">';
        newTag += '<span>Best Seller</span>';
        newTag += '</div>';
      } else if ( data.tags[j] == 'badge new' ){
        newTag += '<div class="new-sale-tag badge-tag">';
        newTag += '<span>New</span>';
        newTag += '</div>';
      } else if ( data.tags[j] == 'badge online only' ){
        newTag += '<div class="online-only-tag badge-tag">';
        newTag += '<span>Online Only</span>';
        newTag += '</div>';
      } else if ( data.tags[j] == 'badge low stock' ){
        newTag += '<div class="low-stock-tag badge-tag">';
        newTag += '<span>Low Stock</span>';
        newTag += '</div>';
      } else if ( data.tags[j] == 'use recyclable' || data.tags[j] == 'badge recyclable' ){
        newTag += '<div class="recyclable-tag badge-tag has-icon">';
        newTag += '<span>Recyclable</span>'; 
        newTag += '</div>';
      } 
    }

    for (var j = 0; j < data.tags.length; j++){
      if (data.tags[j].indexOf('badge ') !== -1){
        newTag += '</div>';
        break;
      }
    }

    return newTag;
  }

  function buildSizeInfo(data) {
    var sizeInfoHtml = '';

    sizeInfoHtml += '<div class="size-info">';
    sizeInfoHtml += '<span class="product-size-label">Sizes</span>';
    sizeInfoHtml += '<div class="sizing-list">';

    sizeInfoHtml += '<span class="size-grid-variant {{highlightSingle}} {{hideSingle}}"><span>S</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightLongSingle}} {{hideLongSingle}}"><span>LS</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightKingSingle}} {{hideKingSingle}}"><span>KS</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightDouble}} {{hideDouble}}"><span>D</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightLongDouble}} {{hideLongDouble}}"><span>LD</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightQueen}} {{hideQueen}}"><span>Q</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightKing}} {{hideKing}}"><span>K</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightSuperKing}} {{hideSuperKing}}"><span>SK</span></span>';
    sizeInfoHtml += '<span class="size-grid-variant {{highlightCaliKing}} {{hideCaliKing}}"><span>CK</span></span>';

    sizeInfoHtml += '</div>';
    sizeInfoHtml += '</div>';

    for (var j = 0; j < data.tags.length; j++){

      var currentTag = data.tags[j];

      if ( currentTag == 'v-size: single' || currentTag == 'size single' ){
        if ( currentTag == 'size single' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightSingle}}/g, "highlight");
        }
        if ( currentTag == 'v-size: single' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideSingle}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: long single' || currentTag == 'size long single' ){
        if ( currentTag == 'size long single' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightLongSingle}}/g, "highlight");
        }
        if ( currentTag == 'v-size: long single' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideLongSingle}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: king single' || currentTag == 'size king single' ){
        if ( currentTag == 'size king single' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightKingSingle}}/g, "highlight");
        }
        if ( currentTag == 'v-size: king single' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideKingSingle}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: double' || currentTag == 'size double' ){
        if ( currentTag == 'size double' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightDouble}}/g, "highlight");
        }
        if ( currentTag == 'v-size: double' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideDouble}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: long double' || currentTag == 'size long double' ){
        if ( currentTag == 'size long double' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightLongDouble}}/g, "highlight");
        }
        if ( currentTag == 'v-size: long double' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideLongDouble}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: queen' || currentTag == 'size queen' ){
        if ( currentTag == 'size queen' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightQueen}}/g, "highlight");
        }
        if ( currentTag == 'v-size: queen' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideQueen}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: king' || currentTag == 'size king' ){
        if ( currentTag == 'size king' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightKing}}/g, "highlight");
        }
        if ( currentTag == 'v-size: king' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideKing}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: super king' || currentTag == 'size super king' ){
        if ( currentTag == 'size super king' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightSuperKing}}/g, "highlight");
        }
        if ( currentTag == 'v-size: super king' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideSuperKing}}/g, "showSize");
        }


      } else if ( currentTag == 'v-size: cali king' || currentTag == 'size cali king' ){
        if ( currentTag == 'size cali king' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{highlightCaliKing}}/g, "highlight");
        }
        if ( currentTag == 'v-size: cali king' ){
          sizeInfoHtml = sizeInfoHtml.replace(/{{hideCaliKing}}/g, "showSize");
        }

      } else if ( currentTag == 'v-size: all'  ){

        sizeInfoHtml = sizeInfoHtml.replace(/{{hideSingle}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideLongSingle}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideKingSingle}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideDouble}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideLongDouble}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideQueen}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideKing}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideSuperKing}}/g, "showSize");
        sizeInfoHtml = sizeInfoHtml.replace(/{{hideCaliKing}}/g, "showSize");
      }
    }
    return sizeInfoHtml;
  }

  function buildImages(data) {
    var html = '';
    if (images && Array.isArray(images) && images.length > 0) {
      html += '<div class="card__media bpf">';
      var aspectRatio = '',
        rangeWidths = boostPFSRangeWidths;

      var dataSrcSet = '',
        imgAlt = data.title,
        flipImageSrcSet = '';

      var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
        boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
        boostPFSThemeConfig.custom.show_secondary_image == true;

      for (var i = 0; i < rangeWidths.length; i++) {
        dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

        if (activeSwapImage) {
          flipImageSrcSet += Utils.optimizeImage(images[(images.length - 1)]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
        }

        if (i < rangeWidths.length - 1) {
          dataSrcSet += ', ';

          if (activeSwapImage) {
            flipImageSrcSet += ', ';
          }
        }
      }

      aspectRatio = images[0]['width'] / images[0]['height'];
      html += '<div class="media media--transparent media--hover-effect"><img class="motion-reduce img-bpf-01"' +
        'loading="lazy"' +
        'srcset="' + dataSrcSet + '" ' +
        'height="' + images[0].height + '" ' +
        'width="' + images[0].width + '" ' +
        'sizes="(min-width: 1100px) 535px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)"' +
        'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
        'alt="' + imgAlt + '" />';

      if (activeSwapImage) {
        html += '<img class="motion-reduce img-bpf-02"' +
        'loading="lazy"' +
        'height="450" ' +
        'width="450" ' +
        'srcset="' + flipImageSrcSet + '" ' +
        'src="' + Utils.optimizeImage(images[(images.length - 1)].src, '450x450') + '" ' +
        'alt="' + imgAlt + '" />';
      }
      html += '</div>';
      html += '</div>';
    } else {
      html += `<div class="card__content">
                <div class="card__information">
                  <h3 class="card__heading">
                    <a href="#" class="full-unstyled-link">
                      ${data.title}
                    </a>
                  </h3>
                </div>
              </div>`;
    }
    return html;
  }

  function buildCardProductClass(data) {
    var html = '' + boostPFSThemeConfig.custom.card_style;
    if (!images) {
      html += ' card--text';
    } else {
      html += ' card--media';
    }
    if (boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (!images && boostPFSThemeConfig.custom.card_style == 'card') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardInnerProductClass(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' color-' + boostPFSThemeConfig.custom.card_color_scheme;
    }
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html += ' ratio';
    }
    return html;
  }

  function buildCardIsHeadingFive(data) {
    var html = '';
    if (images || boostPFSThemeConfig.custom.card_style == 'standard') {
      html = 'h5';
    }
    return html;
  }

  function buildVendor(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
      boostPFSThemeConfig.custom.show_vendor === true) {
      html = boostPFSTemplate.vendorHtml;
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
    var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
    var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
    var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount).replace('From ', '') : priceAmount;
    var moneyPriceWithoutDecimal = !data.available ? 'In-store Only' : Utils.formatMoney(Math.floor(data.price_min), Globals.moneyFormat, true);
    console.log('moneyPriceWithoutDecimal', moneyPriceWithoutDecimal);
    var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''

    let asopPrice = 0
    let asopFlag = false;
    let asopMattressFlag = false;
    let asopEnsembleFlag = false;
    for (let i=0;i< data.tags.length;i++){
      if(data.tags[i] === 'ASOP'){ asopFlag = true}
      if(data.tags[i] === 'type mattress'){ asopMattressFlag = true}
      if(data.tags[i] === 'v-selection: ensemble'){ asopEnsembleFlag = true}
      asopPrice = "2,999"
    }

    let asopClass = ''
    if( asopFlag ){
      if (asopMattressFlag){ asopPrice = "$5,169"; asopClass = 'asopMattressFlag'}
      if (asopEnsembleFlag){ asopPrice = "$5,899"; asopClass = 'asopEnsembleFlag'}
    }

    let manualFrom = false;

    if (data.template_suffix == "bundles-size") {
      manualFrom = true;
    }

    console.log('template_suffix', data.template_suffix);

    let finalPrice = asopFlag ? asopPrice : moneyPriceWithoutDecimal

    html = `<div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}">
          <div class="price__container">
            <div class="price__regular">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span class="price-item price-item--regular bpfp-01">
                ${manualFrom ? '<span>From&nbsp;</span> ' : ''} ${finalPrice}
              </span>
            </div>
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">
                ${boostPFSConfig.label.regular_price}
              </span>
              <span>
                <s class="price-item price-item--regular bpfp-02">
                  ${compareAtPrice}
                </s>
              </span>
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last sp-from-boost">${manualFrom ? 'From&nbsp;' : ''}${finalPrice}</span>
            </div>
            <small class="unit-price caption ${unitPriceClass}">
              <span class="visually-hidden">${boostPFSConfig.label.unit_price}</span>
              <span class="price-item price-item--last">
                <span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
                <span aria-hidden="true">/</span>
                <span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
              </span>
            </small>
          </div>
        </div>`
    return html;
  }

  function buildSoldOutLabel() {
    // Build Sold out label
    var soldOutLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
      soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
    }
    return soldOutLabel;
  }

  function buildSaleLabel() {
    // Build Sale label
    var saleLabel = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
      saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
    }
    return saleLabel;
  }

  function buildReview(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
      boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
      var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
    }
    return html;
  }
    
  function getAspectRatio(data) {
    var width = (data == null) ? '535' : data.width;
    var height = (data == null) ? '535' : data.height;

    return width / height;
  }

  function getRatioImage(data) {
    var ratio = 1;
    if (images && boostPFSThemeConfig.custom.media_size == 'portrait') {
      ratio = 0.8;
    } else if (images && boostPFSThemeConfig.custom.media_size == 'adapt') {
      ratio = getAspectRatio(data.images[0]);
    }
    if (ratio === 0 || ratio === null) {
      ratio = 1;
    }
    return ratio;
  }

  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        var paramSort = Globals.queryParams.sort || '';
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          var isSelected = ''
          if(paramSort == k) {
            isSelected = 'selected="selected"'
          }
          sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  ProductSorting.prototype.render = function () {
    jQ(Selector.topSorting).html(this.compileTemplate());

    if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
      jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
    }

    var labelSort = '';
    var paramSort = Globals.queryParams.sort || '';
    var sortingList = Utils.getSortingList();
    if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
      labelSort = sortingList[paramSort];
    } else {
      labelSort = Labels.sorting;
    }

    jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  }

  // Build Sorting event
  ProductSorting.prototype.bindEvents = function() {
    jQ(Selector.topSorting + ' .facet-filters__sort').change(function(e) {
      e.preventDefault();
      FilterApi.setParam('sort', jQ(this).val());
      FilterApi.setParam('page', 1);
      FilterApi.applyFilter('sort');
    });
  };

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function(data) {
    if (!data) data = this.data;
  }

  // Build Additional Elements
  Filter.prototype.afterRender = function(data, eventType) {
    if (!data) data = this.data;
    jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
  };

  // Fastship: PENDING AS I'M NOT SURE THIS FUNCTION IS STILL USED.
  // FilterTree.prototype.afterRender = function() {
  //   if ( fastShipEnabled || fastCollectEnabled ){
  //       fastShipFastCollectLocationDisplay();
  //       fastShipFastCollectProductFilter();
  //   }
  // }

  FilterOption.prototype.afterRender = function() {
    if (this.filterOptionId == "pf_p_price_range") {
      var html = '<ul class="range-labels"><li>Value</li><li>Quality</li><li>Premium</li></ul>';
      if (this.$element.find(".range-labels").length == 0) {
        this.$element.append(html);
      }
    }
  
    if (this.filterOptionId == "pf_t_comfort_level") {
      if (this.$element.find(".comfort-level-container").length == 0) { 
        this.$element.find('.boost-pfs-filter-option-content').prepend('<div class="comfort-level-container"><div class="comfort-firm">Firm</div><div class="comfort-medium">Medium</div><div class="comfort-plush">Plush</div></div>');
      }
      if (this.$element.find(".more-info").length == 0) {
          this.$element.append('<a href="/pages/comfort-level" class="more-info">More information</a>');
      }
    }
  }

  // Assign image
  FilterOptionItem.prototype.afterRender = function() {
      	
    // ADD IMAGES TO SIZE FILTER
    if (this.parent.filterOptionId == "pf_t_size") {
        var images = jQ("#images-for-filter-size");
        var sizeTitle = this.label;
        var imageSrc = images.find('[data-filter-size="'+sizeTitle+'"]').html();
        if(this.$element.find(".icon-wrap").length == 0){
            if(imageSrc){
            this.$element.find('button').prepend('<div class="icon-wrap"><img class="filter-size-icon" src="'+imageSrc+'"></div>');
            }
        }
    }
  
    // ADD IMAGES TO TYPE FILTER
    if (this.parent.filterOptionId == "pf_pt_type") {
        var images = jQ("#images-for-filter-blocks");
        var sizeTitle = this.label;
        var imageSrc = images.find('[data-filter-type="'+sizeTitle+'"]').html();
        if(this.$element.find(".bed-icon").length == 0){
            if(imageSrc){
                this.$element.find('button').prepend('<div class="bed-icon"><img src="'+imageSrc+'"></div>');
            }
        }
        var newText = this.label.replace('Type Mattress', 'Mattress Only').replace('Type Bed', 'Bed Ensemble').replace('Type Pillow', 'Pillows').replace('Mattress Only Protector', 'Mattress Protectors').replace('Type Sheet', 'Sheets').replace('Type Duvet', 'Duvets');
      
        this.$element.find('.boost-pfs-filter-option-value').html(newText);
    }
    
    // ADD IMAGES TO RANGE FILTER
    if (this.parent.filterOptionId == "pf_t_range") {
        var images = jQ("#images-for-filter-blocks");
        var sizeTitle = this.label.replace('Hd', 'HD');
        var imageSrc = images.find('[data-filter-range="'+sizeTitle+'"]').html();
        if(imageSrc) {
          var imageSrcStripParam = imageSrc.split('?')[0];
          if(this.$element.find(".brand-logo").length == 0){
            if(imageSrcStripParam){
                this.$element.find('button').prepend('<div class="brand-logo h"><img src="'+imageSrcStripParam+'"></div>');
                this.$element.find('.boost-pfs-filter-option-value').remove();
            }
          }
        } else {
          if(this.$element.find(".brand-logo").length == 0){
            if(imageSrc){
                this.$element.find('button').prepend('<div class="brand-logo h"><img src="'+imageSrc+'"></div>');
                this.$element.find('.boost-pfs-filter-option-value').remove();
            }
          }
        }
    }
  
    // ADD IMAGES TO USE FILTER
    if (this.parent.filterOptionId == "pf_t_use") {
        var images = jQ("#images-for-filter-blocks");
        var sizeTitle = this.label;
        var imageSrc = images.find('[data-filter-use="'+sizeTitle+'"]').html();
        if(this.$element.find(".icon-container").length == 0){
            if(imageSrc){
                this.$element.find('button').prepend('<div class="icon-container"><div class="icon-round"><img class="filter-size-icon" src="'+imageSrc+'"></div></div>');
            }
        }
    }    
    
  }


  /************************** END BUILD TOOLBAR **************************/

})();
